/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".spray-study-position[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}.spray-study-all-btn[_ngcontent-%COMP%]{margin-top:auto;text-align:right;padding-bottom:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study.component.css.shim.ngstyle.js.pre-build-optimizer.js